import { render, staticRenderFns } from "./CrmProgress.vue?vue&type=template&id=572f10c6&scoped=true&"
import script from "./CrmProgress.vue?vue&type=script&lang=ts&"
export * from "./CrmProgress.vue?vue&type=script&lang=ts&"
import style0 from "./CrmProgress.vue?vue&type=style&index=0&id=572f10c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572f10c6",
  null
  
)

export default component.exports